export default "__VITE_ASSET__216a94ae__"